import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './styles/performance.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import { ChakraProvider } from '@chakra-ui/react'
import theme from './theme';
import { Provider } from 'react-redux';
import { store } from './Redux/store';
import ErrorHandler from './utils/ErrorHandler';
// The root reducer is already defined in store.js, so we don't need these imports or definitions here
// import { watchLaterReducer } from './Redux/WatchLater/reducer';
// import { combineReducers } from 'redux';

// This rootReducer definition is not used and conflicts with the one in store.js
// const rootReducer = combineReducers({
//   // ...existing code...
//   watchLater: watchLaterReducer,
//   // ...existing code...
// });

// Global error handlers
window.addEventListener('error', (event) => {
  ErrorHandler.handleError(
    'window.onerror',
    event.error || event.message,
    null,
    { silent: true }
  );
});

window.addEventListener('unhandledrejection', (event) => {
  ErrorHandler.handleError(
    'unhandledPromiseRejection',
    event.reason,
    'An unexpected error occurred',
    { silent: false }
  );
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <ChakraProvider theme={theme}>
        <BrowserRouter basename="/">
          <App />
        </BrowserRouter>
      </ChakraProvider>
    </Provider>
  </React.StrictMode>
);

// Splash screen removal is now controlled by App.js after data + images are loaded
// This fallback ensures the splash is removed even if something goes wrong (max 8s)
setTimeout(() => {
  const loadingEl = document.getElementById('app-loading');
  if (loadingEl) {
    loadingEl.style.opacity = '0';
    loadingEl.style.transition = 'opacity 0.5s ease-out';
    setTimeout(() => loadingEl.remove(), 500);
  }
}, 8000);
